import { Component } from '@angular/core';

@Component({
    selector: 'app-custom-header-legalese',
    templateUrl: './custom-header-legalese.component.html',
    styleUrls: ['./custom-header-legalese.component.scss'],
})
export class CustomHeaderLegaleseComponent {
}
